module.exports = __webpack_public_path__ + "static/media/ico_download_yac_active.6e1cc3c5.svg";